export default {
  app: {
    privacy: {
      policy: 'privaatheidsbeleid',
      expansive: 'Deur Expansive te gebruik, stem jy in tot die Expansive {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sessie het verval',
    sessionExpiredDescription:
      'Jou sessie het verval. Meld asseblief weer aan om die toepassing te gebruik.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Kies taal',
      chooseLanguageDescription:
        'Kies jou voorkeurtaal vir die toepassing. Dit sal die taal van die koppelvlak en inhoud verander.',
    },
    userSelection: {
      cancel: 'Kanselleer',
      createNewUser: 'Hul naam is nie gelys nie',
      newUser: 'Nuwe gebruiker',
      selectAnExistingUser: 'Kies ’n bestaande gebruiker',
      selectUserHint: 'Kies ’n bestaande gebruiker of skep ’n nuwe een om voort te gaan.',
      startTypingToSearch: 'Begin tik...',
    },
    verification: {
      codeVerification: {
        continue: 'Gaan voort',
        header: 'Voer terrein toegangskode in',
        invalidCode: 'Ongeldige kode, probeer asseblief weer.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Gaan voort sonder om ligging te verifieer',
        enterSiteAccessCode: 'Voer terrein toegangskode in',
        locationNotEnabledOrAvailable: 'Waarom sien ek dit?',
        notAvailable: {
          description: 'GPS-ligging word nie op hierdie toestel ondersteun nie.',
          header: 'Ligging nie ondersteun nie',
        },
        notEnabled: {
          description: 'Liggingdienste is nie geaktiveer nie of toestemming is nie verleen nie.',
          header: 'Ligging nie geaktiveer nie',
        },
        notVerified: {
          description: 'GPS dui aan dat jy nie op die terrein is nie.',
          header: 'Ligging nie geverifieer nie',
        },
        tryAgain: 'Probeer weer',
        unavailable: {
          description: 'Ons kon nie jou GPS-ligging verifieer nie.',
          header: 'Ligging nie beskikbaar nie',
        },
        unknown: {
          description: 'Ons kan nie jou ligging bepaal nie.',
          header: 'Ligging onbekend',
        },
        verified: {
          description: 'GPS dui aan dat jy op die terrein is.',
          header: 'Ligging geverifieer',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Geen bates gevind',
        emptyDescription: 'Daar is geen bates geassosieer met hierdie werksorder nie.',
        warrantyParts: 'Waarborg vir onderdele verval',
        serialNumber: 'Serie nommer',
        none: '<geen>',
      },
      updates: {
        emptyTitle: 'Geen opdaterings gevind',
        emptyDescription: 'Daar is geen opdaterings vir hierdie werksorder nie.',
        unknownUser: 'Onbekende gebruiker',
        none: 'Geen',
        addComment: {
          buttonLabel: 'Voeg kommentaar by',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Gevare',
          no: 'Nee',
          yes: 'Ja',
        },
      },
    },
    attachmentsList: {
      attachments: 'Hegtings',
      documents: 'Dokumente',
      siteDocuments: 'Terrein Dokumente',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Gevare',
        induction: 'Induksie',
        safeToProceed: 'Dit is veilig om voort te gaan',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Vervaldatum',
        activeSessions: 'Aktiewe sessies',
        activeSessionsDescription:
          "Jy is reeds ingecheck in die volgende werksorders. Jy moet uitcheck van hierdie werksorders voordat jy in 'n nuwe werksorder kan incheck.",
        resumeSession: 'Hervat',
        startTime: 'Begin om',
        unexpectedErrorTitle: 'Onverwagte fout',
        unexpectedErrorMessage:
          "Daar het 'n onverwagte fout voorgeval terwyl daar probeer is om jou sessies te skep. Probeer asseblief weer later.",
        engineerNotFound: 'Ingenieur nie gevind nie',
        engineerNotFoundDescription:
          'Die ingenieur wat jy probeer inboek, is nie in die stelsel gevind nie. Kontak asseblief jou administrateur.',
      },
      verification: {
        code: {
          description:
            'Om in te boek, verkies asseblief die 4-syfer kode van die terrein bestuurder of aangewese kontak.',
        },
        geo: {
          continue: 'Gaan voort',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Verkry asseblief die toegangskode van die terreinbestuurder of aangewese kontak om jou besoek te voltooi.',
            checkOut: 'Teken uit',
            completeBeforeLeaving: 'Voltooi asseblief die volgende vorm voordat jy vertrek.',
            continue: 'Gaan voort',
            noResolutionSelected: "Kies asseblief 'n oplossing voordat jy voortgaan.",
            quoteRequired: {
              hint: 'Besoek voltooi, kwotasie volg',
              label: 'Kwotasie vereis',
            },
            returnVisitRequired: {
              hint: 'Ons sal weer terugkeer om te voltooi',
              label: 'Terugbesoek vereis',
            },
            serviceCompleted: {
              hint: 'Geen verdere aksie vereis nie',
              label: 'Diens voltooi',
            },
            uploadCheckout: "Laai 'n lêer, foto of video op",
            visitNotes: 'Besoek aantekeninge',
            workOrderResolution: 'Werksorder oplossing',
            enterNotes: 'Voer enige aantekeninge hier in...',
            errors: {
              timedOut: 'Tyd verstreke, meer as 30 sekondes. Probeer asseblief weer.',
              closingSession: 'Fout tydens sluiting van sessie',
            },
          },
          success: {
            description:
              'Dankie dat jy {site} besoek het. | {site} het nog 1 oop werksorder oor. | {site} het {count} oop werksorders oor.',
            endVisit: 'Eindig besoek',
            header: 'Jy het suksesvol uitgecheck',
            viewWorkOrders: "Teken in by 'n ander werksorder",
          },
          verification: {
            code: {
              description:
                'Om uit te teken, verkies asseblief die 4-syfer kode van die terrein bestuurder of aangewese kontak.',
              continue: 'Gaan voort',
            },
            geo: {
              checkOut: 'Teken uit',
              continue: 'Gaan voort',
            },
          },
        },
        detail: {
          assets: 'Bates',
          call: 'Bel',
          checkOut: 'Teken uit',
          closed: 'Gesluit',
          details: 'Besonderhede',
          dueBy: 'Vervaldatum',
          manageEngineers: 'Bestuur ingenieurs',
          notAvailable: 'Nie beskikbaar nie',
          pointOfContact: 'Kontakpersoon',
          siteAccessTimes: 'Tydperke van terrein toegang',
          siteAccessInstructions: 'Toegang instruksies',
          siteAddress: 'Terrein adres',
          siteNotes: 'Terrein aantekeninge',
          siteTelephone: 'Terrein telefoon',
          siteLocation: 'Terrein ligging',
          updates: 'Opdaterings',
          more: 'Meer',
          mismatchErrorTitle: 'Werksorder fout',
          mismatchErrorMessage:
            'Die werksorder wat jy probeer toegang verkry, stem nie ooreen met die een waarin jy tans ingeboek is nie. Kontroleer asseblief jou werksorder en probeer weer.',
          siteDocuments: 'Terrein dokumente',
          validFrom: 'Geldig vanaf',
          validUntil: 'Geldig tot',
          documentName: 'Dokument naam',
          documentType: 'Dokument tipe',
          attachments: 'Werksorder lêers',
          download: 'Laai af',
          workDetails: 'Werk besonderhede',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Voeg assistent ingenieur by',
            assistantEngineers: 'Assistent ingenieurs',
            description:
              'Vir veiligheidsredes, spesifiseer asseblief die name van elke ingenieur op die terrein.',
            editMainEngineer: 'Wysig hoof ingenieur',
            errors: {
              creatingEngineer: 'Fout tydens skep van ingenieur',
              creatingSession: 'Fout tydens skep van sessie',
            },
            header: 'Ingenieurs op terrein',
            mainEngineer: 'Hoof ingenieur',
            newAssistantEngineer: 'Voer hul volle naam in',
            next: 'Volgende',
            removeEngineer: 'Verwyder ingenieur',
            selectExistingAssistantEngineer: 'Begin tik hul naam',
          },
          index: {
            description:
              'Vir veiligheidsredes, spesifiseer asseblief die name van elke ingenieur op die terrein.',
            errorCreatingEngineer: 'Fout tydens skep van ingenieur, probeer asseblief weer.',
            header: 'Ingenieurs op terrein',
            hintMainEngineer: 'Voer hoof ingenieur se volle naam in',
            newMainEngineer: 'Nuwe hoof ingenieur',
            next: 'Volgende',
            selectExistingMainEngineer: "Kies 'n bestaande hoof ingenieur",
            yes: 'Ja',
            no: 'Nee',
            mainEngineerLabel: 'Is jy die hoof ingenieur?',
          },
        },
        index: {
          callUsOn: 'Bel ons op {phoneNumber}',
          description: 'Kan nie vind wat jy soek nie?',
          dueBy: 'Vervaldatum',
          header: 'Kies werksorder',
          notAvailable: 'Nie beskikbaar nie',
          searchWorkOrders: 'Soek werksorders...',
        },
        manageEngineers: {
          manageEngineers: 'Bestuur ingenieurs',
          notWorking: 'Inaktiewe werkers',
          pause: 'Pouse',
          resume: 'Hervat',
          workingNow: 'Aktiewe werkers',
          startTime: 'Begin tyd',
          endTime: 'Eind tyd',
          duration: 'Duur',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Terugvoer',
            feedbackDescription:
              'Verskaf asseblief terugvoer oor die werksorder om ons te help om ons dienste te verbeter.',
            feedbackLabel: 'Terugvoer',
            filesLabel: 'Hegtings',
            submissionLabel: 'Dien terugvoer in',
          },
          hazards: {
            back: 'Gaan terug',
            hazards: 'Gevare',
            next: 'Volgende',
            no: 'Nee',
            noTasksForHazard: 'Daar is geen take om te voltooi vir hierdie gevaar nie.',
            yes: 'Ja',
          },
          induction: {
            continue: 'Gaan voort',
            induction: 'Induksie',
          },
          index: {
            checkIn: 'Teken in',
            description:
              'Voltooi asseblief die volgende risiko-evaluering vir die geselekteerde werk.',
            fail: 'Kon nie begin werksorder kontrole verwerk nie.',
            haltMessage:
              "Potensiële risiko's opgespoor. Stop asseblief werk, hersien veiligheidsriglyne, en kontak jou toesighouer vir verdere instruksies.",
            header: 'Begin werk kontrole',
            endVisit: 'Eindig besoek',
            leaveFeedback: 'Laat terugvoer',
          },
          safeToProceed: {
            continue: 'Gaan voort',
            safeToProceed: 'Dit is veilig om voort te gaan',
          },
        },
      },
    },
    index: {
      title: 'Welkom',
      description: 'Skandeer die QR-kode op jou ligging om te begin.',
    },
    login: {
      errorTitle: 'Onverwagte fout',
      errorMessage:
        "Daar het 'n onverwagte fout voorgeval. Probeer asseblief om die QR-kode weer te skandeer.",
    },
    unauthenticated: {
      welcome: {
        title: 'Welkom by {site}',
        description:
          'Voordat ons enige werksorders aan jou kan wys, moet ons jou besonderhede verifieer. Klik asseblief op die knoppie hieronder om voort te gaan.',
        next: 'Gaan voort',
      },
      index: {
        errorTitle: 'Onverwagte fout',
        errorMessage:
          "Daar het 'n onverwagte fout voorgeval. Probeer asseblief om die QR-kode weer te skandeer.",
      },
      contractor: {
        title: 'Vir wie werk jy?',
        contractor: 'Kontrakteur',
        contractorLabel: 'Begin tik jou maatskappy se naam',
        contractorHint: 'Jy moet 3 karakters of meer invoer om resultate te sien',
        defaultSelectPlaceholder: '--Groot asseblief--',
        next: 'Volgende',
      },
      user: {
        title: 'Wie is jy?',
        cancel: 'Kanselleer',
        createNewUserLabel: 'My naam is nie gelys nie',
        existingUserLabel: 'Begin tik jou naam',
        existingUserHint: 'Jy moet 3 karakters of meer invoer om resultate te sien',
        newUserLabel: 'Voer jou volle naam in',
        next: 'Volgende',
        user: 'Gebruiker',
      },
      verification: {
        methods: {
          add: {
            add: 'Voeg verifikasie metode by',
            defaultSelectPlaceholder: '--Groot asseblief--',
            emailLabel: 'E-pos',
            existingMethodWarning:
              "Jy het reeds 'n hangende versoek vir hierdie verifikasie metode wat wag op administrateur goedkeuring. Om 'n nuwe een by te voeg, sal dit oorskryf.",
            method: 'Metode',
            methodLabel: 'Metode',
            mobileCountryHint: 'Kies asseblief jou landkode',
            mobileCountryLabel: 'Mobiele landkode',
            mobileHint: 'Voer asseblief jou mobiele nommer in',
            mobileLabel: 'Mobiel',
            title: 'Voeg verifikasie metode by',
          },
          confirm: {
            confirm: 'Bevestig',
            description: 'Bevestig asseblief jou verifikasie metode om voort te gaan.',
            label: 'Voer jou kode in',
            resend: 'Stuur weer',
            resendPrompt: "Nie ontvang nie 'n kode?",
            title: 'Bevestig Verifikasie Metode',
          },
          confirmed: {
            description:
              'Jy sal kennisgewing ontvang sodra hierdie verifikasie metode deur jou administrateur goedgekeur is, en jy kan dit dan begin gebruik om jou identiteit te verifieer.',
            forceApproval: 'Tot dit goedgekeur is, kan jy nie toegang verkry tot werksorders nie.',
            nonForceApproval:
              'Intussen kan jy voortgaan om toegang te verkry tot werksorders met beperkte toegang.',
            nonForceApprovalButtonLabel: 'Voortgaan met beperkte toegang',
            title: 'Wag op goedkeuring',
          },
          addNew: 'Voeg nuwe verifikasie metode by',
          description:
            'Ons moet jou identiteit verifieer om jou volle toegang tot die werksorder te gee.',
          email: 'E-pos',
          hint: "Ons sal 'n skakel na jou geselekteerde verifikasie metode stuur wat jou volle toegang tot die werksorder gee. As jy enige bestaande verifikasie metodes wil verander, kontak asseblief jou administrateur.",
          label: "Kies 'n verifikasie metode",
          next: 'Volgende',
          pendingHint: 'Wag op goedkeuring van jou administrateur',
          sms: 'SMS',
          title: 'Verifikasie',
        },
        optional: {
          hint: 'Deur jou gebruikers besonderhede te verifieer, sal jy volle toegang tot die werksorder kry',
          label: 'Wil jy jou gebruikers besonderhede verifieer?',
          next: 'Volgende',
          no: 'Nee',
          noHint:
            'Ek wil nie my gebruikers besonderhede verifieer nie en voortgaan met beperkte toegang tot die werksorder',
          title: 'Verifikasie',
          yes: 'Ja',
          yesHint:
            'Ek wil my gebruikers besonderhede verifieer en volle toegang tot die werksorder kry',
        },
        sent: {
          description:
            'N aanmeldskakel is gestuur na {identifier}. Klik asseblief op die skakel om jou aanmelding te voltooi.',
          title: 'Aanmeldskakel gestuur',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Gister',
      today: 'Vandag',
      days: {
        monday: 'Maandag',
        tuesday: 'Dinsdag',
        wednesday: 'Woensdag',
        thursday: 'Donderdag',
        friday: 'Vrydag',
        saturday: 'Saterdag',
        sunday: 'Sondag',
      },
      months: {
        january: 'Januarie',
        february: 'Februarie',
        march: 'Maart',
        april: 'April',
        may: 'Mei',
        june: 'Junie',
        july: 'Julie',
        august: 'Augustus',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Desember',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Iets het verkeerd gegaan',
      message: 'Probeer asseblief om die QR-kode weer te skandeer.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Onbekende gebruiker',
      },
      none: 'Geen',
      types: {
        stateTransition: 'Status verander',
        contractorAssigned: 'Kontrakteur toegeken',
        engineerAssigned: 'Ingenieur toegeken',
        serviceAssigned: 'Diens toegeken',
        priorityChanged: 'Prioriteit verander',
        actionableDateChanged: 'Hanteerbare datum verander',
        dueDateChanged: 'Vervaldatum verander',
        etaDateChanged: 'Geskatte aankomstdatum verander',
        spendLimitApproved: 'Bestedingsgrens goedgekeur',
        spendLimitCancelled: 'Bestedingsgrens versoek gekanselleer',
        spendLimitRejected: 'Bestedingsgrens versoek verwerp',
        spendLimitRequested: 'Bestedingsgrens versoek',
        jobSheetUploaded: 'Werkblad opgelaai',
        slaAlertSent: 'Tyd om te attend oortref SLA waarskuwing',
        issuedWorkPermit: 'Werkpermit uitgegee',
        requestForServiceSent: 'Diensversoek gestuur',
        comment: 'Kommentaar bygevoeg',
        unknown: 'Onbekende gebeurtenis',
      },
      labels: {
        actionableDate: 'Hanteerbare datum',
        comment: 'Kommentaar',
        file: 'Lêer',
        contractor: 'Kontrakteur',
        dueDate: 'Vervaldatum',
        etaDate: 'Geskatte aankomstdatum',
        engineer: 'Ingenieur',
        priority: 'Prioriteit',
        requestForService: 'Diensversoek',
        service: 'Diens',
        spendLimit: 'Bestedingsgrens',
        status: 'Status',
        workPermit: 'Werkpermit',
      },
    },
  },
}
